import storage from '../storage'
import isClient from './isClient'

const storageName = `${APP_NAME}_${BUILD_ENV}`

export const getSourceUrl = () => {
  //TO DISCUSS:
  // - vale transformar o getSourceURL em um objeto?
  // - eg: const { sourceUrl, sourceUrlWithQuerys, isAdsSourceURL } = getSourceUrl()
  // - pode ser uma refatoração a fazer após add testes aqui

  if (isClient()) {
    const sourceUrl = storage.session.getItem('source_url')
    if (sourceUrl) {
      return sourceUrl
    }
    return window.location.href
  }
}

export const getSourceUrlWithQuerys = ({
  experiment = '',
  variant = ''
} = {}) => {
  if (isClient()) {
    const sourceUrl = getSourceUrl()
    const isValidVwoData = experiment && variant
    const partner = storage.session.getItem(`${storageName}_leadData`)?.partner

    let sourceUrlWithQuerys = sourceUrl

    if (isValidVwoData) {
      sourceUrlWithQuerys = `${sourceUrlWithQuerys}${
        !sourceUrlWithQuerys.includes('?') ? '?' : '&'
      }lead_t=${experiment}&lead_f=${variant}`
    }

    if (partner) {
      sourceUrlWithQuerys = `${sourceUrlWithQuerys}${
        !sourceUrlWithQuerys.includes('?') ? '?' : '&'
      }utm_source=${partner}`
    }

    return sourceUrlWithQuerys
  }
}

export const getIsAdsSourceURL = () => {
  if (isClient()) {
    const isAdsSourceURL = storage.session.getItem('has_ads_source_url')
    return isAdsSourceURL ?? undefined
  }
}

const isAdsSourceURL = (searchParams) => {
  const utm_sou = new URLSearchParams(searchParams).get('utm_sou')
  const utm_source = new URLSearchParams(searchParams).get('utm_source')

  const adsList = [
    'acordo_certo',
    'acordocerto',
    'acordo-certo',
    'ac',
    'meta',
    'facebook',
    'fb',
    'instagram',
    'ig',
    'tiktok',
    'pangle',
    'iq_360',
    'iq360',
    'iq',
    'igoal',
    'dgmax',
    'afiliados',
    'afiliado',
    'google',
    'mobills',
    'pinterest',
    'twitter',
    'liftoff'
  ]

  return adsList?.some((publisher) => {
    return publisher === utm_sou || publisher === utm_source
  })
}

export const setSourceUrl = () => {
  const sourceUrl = storage.session.getItem('source_url')

  if (isClient() && !sourceUrl) {
    const url = window?.location?.href
    storage.session.setItem('source_url', url)

    const hasAdsSourceURL = isAdsSourceURL(window?.location?.search)

    if (hasAdsSourceURL) {
      storage.session.setItem('has_ads_source_url', hasAdsSourceURL)
    }
  }
}
